<template>
<div id="background-overview-wrapper">
	<div id="bg-overview-container" v-bind:class="{ 'active' : isActive }">
		<div id="page-arrow-prev" class="page-arrow" v-if="linkPrev" v-on:click="changeOverview('aml')">
			<div class="arr">
				<img width="34" src="../assets/navigation/arrow-left.png" alt="Prev" />
			</div>
		</div>
		<div id="page-arrow-next" class="page-arrow" v-if="linkNext" v-on:click="changeOverview('cll')">
			<div class="arr">
				<img width="34" src="../assets/navigation/arrow-right.png" alt="Next" />
			</div>
		</div>
		<div id="overview-screen">
			<div id="close" v-on:click="closeOverview(which)" v-bind:class="showAML || showCLL ? 'overview-show' : ''">
				<img width="58" height="57" src="../assets/aml-cll/close.png" alt="close" />
			</div>

			<div class="overview overview-main screen-aml" v-bind:class="showAML ? 'overview-show' : ''">
				<img width="903" height="625" src="../assets/aml-cll/overview-aml.png"/>
				<a target="_blank" href="https://www.rxabbvie.com/pdf/venclexta.pdf" id="overview-footnote">
					<img width="363" height="27"  src="../assets/aml-cll/overview-aml-footnote.png" />
				</a>
			</div>

			<div class="overview overview-main screen-cll"  v-bind:class="showCLL ? 'overview-show' : ''">
				<img width="903" height="534" src="../assets/aml-cll/overview-cll.png" />
				<a target="_blank" href="https://www.rxabbvie.com/pdf/venclexta.pdf" id="overview-footnote">
					<img width="785" height="33"  src="../assets/aml-cll/overview-cll-footnote.png" />
				</a>
			</div>

		</div>
		<footer>
			<img id="footer-logo" width="81" height="14" src="../assets/global/footer-abbvie-logo.png" />
		</footer>
	</div>
</div>
</template>
<script>
export default {
	props: {
		which: {
			type: String
		}
	},
	data() {
		return {
			isActive: false,
			showWhich: this.which || null,
			showAML: false,
			showCLL: false,
			linkPrev: false,
			linkNext: false
		}
	},
	methods: {
		closeOverview(which){
			this.$emit('close-overview',which)
		},
		changeOverview(which){

			switch(which){
				case 'cll':
					this.showAML = false
					this.linkNext = false
					this.showCLL = true
					this.linkPrev = true
				break

				case 'aml':
					this.showAML = true
					this.linkNext = true
					this.showCLL = false
					this.linkPrev = false
				break

			}
		}
	},
	created() {
		let this_ = this

		if(this_.showWhich !== null){
			this_.changeOverview(this_.showWhich)
		} else {
			this_.changeOverview('aml')
		}

		setTimeout(function(){ 
			this_.isActive = true
		},120)

	},
}
</script>

<style scoped>
#background-overview-wrapper {
	background-color: #ebedf0;
	position: fixed;
	display: grid;
	place-items: center;
	top: 0;
	left: 0;
	width: 100%;
	height: 100vh;
}

	#bg-overview-container {
		position: relative;
		width: 903px;
		min-height: 625px;
		max-height: 768px;
		opacity: 0;
		transition: all 333ms ease-in-out;
	}

		#bg-overview-container.active {
			opacity: 1;
		}

		#overview-screen {
			display: flex;
			justify-content: center;
			width: 903px;
			height: 625px;
		}

			#close {
				cursor: pointer;
				position: absolute;
				right: -12px;
				z-index: 1;
			}

			#close,
			.overview {
				opacity: 0;
				transition: all 240ms ease-in-out;
			}

			#close.overview-show,
			.overview.overview-show {
				opacity: 1;
			}

			.overview-main {
				margin-left: -25px;
			}

			.overview {
				position: absolute;
			}

			#overview-footnote {
				display: block;
				margin: 9px 0 0 27px;
			}

		#footer-logo {
			position: fixed;
			right: 18px;
			bottom: 18px;
		}


/* arrows */
.page-arrow > div {
	cursor: pointer;
}

#page-arrow-prev,
#page-arrow-next {
	transform: translateY(-50%);
	top: 42%;
}

#page-arrow-prev {
	margin-top: 42px;
	position: absolute;
}

	#page-arrow-prev .arr {
		display: block;
		padding: 48px 15px 48px 0;
	}

	#page-arrow-prev {
		left: -63px;
	}

#page-arrow-next {
	margin-top: 42px;
	position: absolute;
}

	#page-arrow-next .arr {
		display: block;
		padding: 48px 0 48px 15px;
	}

	#page-arrow-next {
		right: -63px;
	}

</style>